import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=55d1dd01&scoped=true&"
import script from "./OrderDetail.vue?vue&type=script&lang=js&"
export * from "./OrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&id=55d1dd01&lang=scss&scoped=true&"
import style1 from "./OrderDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d1dd01",
  null
  
)

export default component.exports